// extracted by mini-css-extract-plugin
export default {"icon":"ChannelList_icon__2Xw8-","nav-icon":"ChannelList_nav-icon__E6x5W","button-clear":"ChannelList_button-clear__ty0j8","loading-value":"ChannelList_loading-value__fHe7v"};